export default {
  BORDER: 'border',
  SHADOW: 'shadow',
  CORNERS: 'all-corners',
  CORNERS_SECTION: 'corners',
};
